module.exports = __webpack_public_path__ + "static/images/solution.66a0aa62d4ddc332d30fb4a3296fef4c.png";